import { format } from 'date-fns/esm';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Card, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { CardContent } from '@sierralabs/core-ui';
import { getPublishedStatusLabel } from '../common/PublishStatusLabels';
import { useGetFormTemplateVersions } from '../FormTemplate.hooks';
const StyledTypography = styled(Typography) `
  font-weight: 500;
`;
export const FormStatusCard = ({ formTemplate }) => {
    const { formTemplateVersions, isLoading, getFormTemplateVersions } = useGetFormTemplateVersions(formTemplate.id);
    useEffect(() => {
        getFormTemplateVersions();
    }, [formTemplate.status, getFormTemplateVersions]);
    const statusLabel = formTemplate.isDeleted
        ? 'Deleted'
        : getPublishedStatusLabel(formTemplate.status);
    return (React.createElement(Card, null,
        React.createElement(CardContent, { background: 'primary' },
            React.createElement(Typography, { variant: 'overline', style: { margin: 0, paddingTop: '20px' } }, "Status"),
            React.createElement(StyledTypography, { variant: 'h4' }, statusLabel)),
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "History"),
                        React.createElement(TableCell, null, "Version"),
                        React.createElement(TableCell, null, "User"))),
                React.createElement(TableBody, null,
                    isLoading && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 4, padding: 'none' },
                            React.createElement(LinearProgress, null)))), formTemplateVersions === null || formTemplateVersions === void 0 ? void 0 :
                    formTemplateVersions.map((version, index) => (React.createElement(TableRow, { key: index },
                        React.createElement(TableCell, null, format(version.created, 'MMM d, yyyy')),
                        React.createElement(TableCell, null, version.version),
                        React.createElement(TableCell, null,
                            version.createdBy.firstName,
                            " ",
                            version.createdBy.lastName)))))))));
};
export default FormStatusCard;
//# sourceMappingURL=FormStatusCard.js.map